/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit OrientationAction/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import ChoiceToggle from 'DesignSystem/ChoiceToggle/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function OrientationAction({
  children,
  viewPath = "/DesignSystem/ImageComparison/Orientation/OrientationAction"
  
}) {
let comparisonOrientationValueData = fromData.useDataValue({ viewPath,
context: 'comparison',
path: 'orientation',
})
let orientationIdValueData = fromData.useDataValue({ viewPath,
context: 'orientation',
path: 'id',
})
let aggregateData = fromAggregate.equals(comparisonOrientationValueData, orientationIdValueData)
let orientationTextValueData = fromData.useDataValue({ viewPath,
context: 'orientation',
path: 'text',
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let onClick = fromHelpers.useOnChange({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<ChoiceToggle
  viewPath={`${viewPath}/ChoiceToggle`}
 width={150}
 paddingBottom={dtSpaceXxs}
 marginLeft={dtSpaceXs}
 paddingTop={dtSpaceXxs}
 data="comparison.orientation"
 data="orientation.id"
 aggregate="/Data/aggregate.js equals"
 isSelected={aggregateData}
 data="orientation.text"
 text={orientationTextValueData}
 onClick={onClick}
/>
{children}
</React.Fragment>)
}